import { c as _c } from "react/compiler-runtime";
import { Autocomplete } from '@base-ui/react/autocomplete';
import { Icon } from '@petsmart-ui/sparky';
import type { ComponentProps, PointerEventHandler, RefObject, SubmitEventHandler } from 'react';
type SearchInputKeyDownHandler = NonNullable<ComponentProps<typeof Autocomplete.Input>['onKeyDown']>;
type SearchControlsProps = {
  controlsRef: RefObject<HTMLDivElement | null>;
  formRef: RefObject<HTMLFormElement | null>;
  inputRef: RefObject<HTMLInputElement | null>;
  onCancel?: () => void;
  onInputFocus: () => void;
  onInputKeyDown: SearchInputKeyDownHandler;
  onSubmit: SubmitEventHandler<HTMLFormElement>;
  query: string;
};
export function SearchControls(t0) {
  const $ = _c(19);
  const {
    controlsRef,
    formRef,
    inputRef,
    onCancel,
    onInputFocus,
    onInputKeyDown,
    onSubmit,
    query
  } = t0;
  const handleCancelPointerDown = _temp;
  let t1;
  if ($[0] !== inputRef || $[1] !== onInputFocus || $[2] !== onInputKeyDown) {
    t1 = <Autocomplete.Input ref={inputRef} aria-label="Search" autoComplete="off" className="header-search__input" data-cs-encrypt={true} onFocus={onInputFocus} onKeyDown={onInputKeyDown} placeholder="Search" />;
    $[0] = inputRef;
    $[1] = onInputFocus;
    $[2] = onInputKeyDown;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Autocomplete.Clear aria-label="Clear search" className="header-search__clear" tabIndex={0}><Icon name="x" size="md" aria-hidden="true" /></Autocomplete.Clear>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = query.trim() ? "submit" : "button";
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icon name="search" size="md" aria-hidden="true" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <button aria-label="Search" className="header-search__submit" type={t3}>{t4}</button>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== formRef || $[9] !== onSubmit || $[10] !== t1 || $[11] !== t5) {
    t6 = <form ref={formRef} className="header-search__form" method="get" onSubmit={onSubmit} role="search">{t1}{t2}{t5}</form>;
    $[8] = formRef;
    $[9] = onSubmit;
    $[10] = t1;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== onCancel) {
    t7 = onCancel && <button className="header-search__cancel" type="button" onClick={onCancel} onPointerDown={handleCancelPointerDown}>Cancel</button>;
    $[13] = onCancel;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== controlsRef || $[16] !== t6 || $[17] !== t7) {
    t8 = <Autocomplete.InputGroup ref={controlsRef} className="header-search__controls">{t6}{t7}</Autocomplete.InputGroup>;
    $[15] = controlsRef;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}
function _temp(event) {
  if (event.button !== 0 || !event.isPrimary) {
    return;
  }
  event.preventDefault();
}